import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";
import { LanguageProvider } from "@/context/LanguageContext";
import LoadingScreen from "@/components/LoadingScreen";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

const ConditionalLoader = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return <LoadingScreen />;
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ConditionalLoader />
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#173F35",
              color: "#F4F1EA",
              border: "1px solid rgba(232,211,195,0.22)",
              borderRadius: 0,
              fontFamily: "inherit",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
